import { colors } from 'styles/colors';
import styled from 'styled-components';

// Two seal photos side by side. The originals are only 320px wide, so they're kept at about that size.
export const Photos = styled.figure`
  margin: 2.5rem 0;

  > div {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;

    @media (min-width: 576px) {
      grid-template-columns: 1fr 1fr;
    }
  }

  .gatsby-image-wrapper {
    border-radius: 0.5rem;
  }

  figcaption {
    margin-top: 0.5rem;
    font-size: 0.85rem;
    line-height: 1.5;
    color: ${colors.muted};
  }
`;
